import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  ContentPopperProps,
  FONT_WEIGHTS,
  SPACING,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {useScaylePaymentMethodState} from '../../scayle-state/useScaylePaymentMethodState';
import {BnplInfoRow} from './BnplInfoRow';
import {LearnMorePopover, usePopover} from './LearnMorePopover';
import {BnplSlotName} from './constants';

interface BelowFieldsSlotProps {
  BnplInfoLayoutComponent: ContentPopperProps['LayoutComponent'];
}

export const BelowFieldsSlot = ({
  BnplInfoLayoutComponent,
}: BelowFieldsSlotProps) => {
  const learnMore = usePopover('bnpl-learn-more');
  const {t} = useTranslation();
  const {hasBnplConsentCheckbox} = useScaylePaymentMethodState();

  const showInfoText = !hasBnplConsentCheckbox;

  return (
    <div
      slot={BnplSlotName.dynamicAreaPaymentOptions}
      data-testid="below-fields-slot"
    >
      {showInfoText ? (
        <StyledBnplInfoRow
          color={COLORS.Black}
          text={t(
            'We need to verify some details before you can use this payment method.',
          )}
          linkText={t('Learn more')}
          onLinkClick={learnMore.openPopover}
          linkTestId="learn-more-link"
        />
      ) : (
        <InfoLinkOnly>
          <LearnMoreLink
            onClick={learnMore.openPopover}
            type="button"
            data-testid="learn-more-link"
          >
            {t('Learn more')}
          </LearnMoreLink>
        </InfoLinkOnly>
      )}

      <LearnMorePopover
        open={learnMore.isOpen}
        onClose={learnMore.closePopover}
        LayoutComponent={BnplInfoLayoutComponent}
      />
    </div>
  );
};

const StyledBnplInfoRow = styled(BnplInfoRow)`
  margin-top: ${SPACING['Y.Xl']};
`;

const InfoLinkOnly = styled.div`
  margin-left: calc(${SPACING['X.Xl']} + ${SPACING['X.Sm']});
`;

const LearnMoreLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 13px;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.2;
  color: ${COLORS.Black};
  letter-spacing: -0.26px;
  text-decoration: none;
  border-bottom: 1px solid ${COLORS.Black};
`;
